const review = [
    {
        id: 1,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:     require('../logos/customer_profile.png'),
    },
    {
        id: 2,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 3,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 4,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 5,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 6,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 7,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 8,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 9,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 10,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },
    {
        id: 11,
        name: 'Vijay',
        time: 'July 2022',
        city: 'Noida, Uttar Pradesh 201301, India',
        rating: 5,
        review: 'Good Knowledge of his job, hard working and well mannered',
        photo:      require('../logos/customer_profile.png'),
    },

    
]

export default review;